module.exports = __webpack_public_path__ + "img/chevron-down.e22f2bd6.svg";